import * as React from 'react';
import {useContext} from 'react';
import {Header} from "../Header";
import {NavBar} from "../NavBar";
import {Footer} from "../Footer";
import Breadcrumb from "../Breadcrumb";
import {AppContext} from "../../context/AppContext";
import {Location} from "react-router";
import {LoadingIndicator} from "../LoadingIndicator";
import {Impersonation} from "../Impersonation";

interface MasterTemplateProps {
  location: Location,
  children?: React.ReactNode,
}

export function MasterTemplate({ location, children }: MasterTemplateProps) {
    const {
      isLoggedIn,
      isLoading,
      getRoutes,
      I18N
    } = useContext(AppContext);

    const ROUTE_CONFIG = getRoutes();

    const isNetworkParticipants = location.pathname === ROUTE_CONFIG.NETWORK_PARTICIPANTS.path
      || location.pathname === ROUTE_CONFIG.NETWORK_PARTICIPANTS.path + '/';
    const isLoginArea = location.pathname.indexOf(ROUTE_CONFIG.LOGIN.path) !== -1
      || location.pathname.indexOf(ROUTE_CONFIG.PASSWORD_RESET.path) !== -1;
    const isBackend = !isNetworkParticipants && !isLoginArea;

    /**
     * skipToContent
     * hands the focus to the main area; scrollIntoView because the page
     * scrolls inside dia-grid, not on the window
     */
    const skipToContent = () => {
      const main = document.getElementById("main-content");

      if (!main) {
        return;
      }

      main.focus({ preventScroll: true });
      main.scrollIntoView({ block: "start" });
    };

    return (
      <>
        { /* first tab stop of the logged-in area: header and navigation are
             13 stops deep, this jumps straight to the content */ }
        { isBackend && (
          <a
            data-skip-to-content
            href="#main-content"
            onClick={ (event) => {
              event.preventDefault();
              skipToContent();
            } }
          >
            { I18N.t("Zum Inhalt springen") }
          </a>
        ) }
        { isLoggedIn() && <Impersonation /> }
        <Header/>
        { isNetworkParticipants ?
          <main data-public>
            { isLoading ? <LoadingIndicator /> : '' }
            { children }
          </main>
         :
          isBackend ?
          <>
            <Breadcrumb/>
            <dia-grid-content>
              <aside>
                <NavBar/>
              </aside>
              <main id="main-content" tabIndex={ -1 }>
                { isLoading ? <LoadingIndicator /> : '' }
                { children }
              </main>
            </dia-grid-content>
          </>
         :
          <main data-login>
            { /* @ts-ignore */ }
            <article style={{ flexWrap: 'wrap' }}>
              { isLoading ? <LoadingIndicator /> : '' }
              { children }
            </article>
          </main>
        }
        <Footer/>
      </>
    )
}
